import { render, staticRenderFns } from "./adformMediaComponent.vue?vue&type=template&id=ebe4dee8&scoped=true&"
import script from "./adformMediaComponent.ts?vue&type=script&lang=js&"
export * from "./adformMediaComponent.ts?vue&type=script&lang=js&"
import style0 from "./adformMediaComponent.vue?vue&type=style&index=0&id=ebe4dee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe4dee8",
  null
  
)

export default component.exports